/* eslint-disable comma-dangle */
/* eslint-disable quotes */
/* eslint-disable quote-props */

var tokens = {
  "intent": {
    "generic": {
      "background": {
        "base.background": "#f6f8fc",
        "base.background.strong": "#ffffff",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.inset": "rgba(171, 182, 203, 0.12)",
        "base.overlay": "rgba(0, 0, 0, 0.48)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.overlay.strong": "rgba(0, 0, 0, 0.8)",
        "base.overlay.subtle": "rgba(0, 0, 0, 0.32)",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#24262c",
        "base.surface.inverted": "#24262c",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.intent": "#464c5b",
        "base.intent.subtle": "#edf0f9",
        "state.disabled": "rgba(37, 44, 56, 0.08)",
        "state.hover": "rgba(171, 182, 203, 0.12)",
        "state.pressed": "rgba(171, 182, 203, 0.24)",
        "state.inactive": "rgba(37, 44, 56, 0.56)",
        "state.inactive.subtle": "rgba(37, 44, 56, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#24262c",
        "base.disabled": "#a8b3cb",
        "base.inverted": "#ffffff",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.inverted.subtle": "#edf0f9",
        "base.subtle": "#6b7388",
        "base.intent": "#5e6b82",
        "base.on.intent": "#eff4fc",
        "base.on.intent.subtle": "#4a5466",
        "state.disabled": "rgba(37, 44, 56, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#4a5466",
        "state.pressed": "#4a5466",
        "state.inactive": "rgba(13, 17, 24, 0.64)",
        "state.inactive.strong": "#252c38",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "#c1cbe0",
        "base.subtle": "#edf0f9",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.16)",
        "base.strong": "#c1cbe0",
        "base.intent": "rgba(94, 107, 130, 0.32)",
        "base.intent.strong": "#24262c",
        "base.intent.subtle": "rgba(94, 107, 130, 0.16)",
        "state.disabled": "rgba(37, 44, 56, 0.12)",
        "state.hover": "rgba(171, 182, 203, 0.12)",
        "state.pressed": "rgba(171, 182, 203, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(13, 17, 24, 0.64)",
        "state.inactive.subtle": "rgba(37, 44, 56, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "activities": {
      "background": {
        "base.background": "#f6f4e9",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#352a06",
        "base.surface.inverted": "#352a06",
        "base.inset": "rgba(231, 196, 63, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#e7c43f",
        "base.intent.subtle": "#f3efd8",
        "state.disabled": "rgba(53, 42, 6, 0.08)",
        "state.hover": "rgba(231, 196, 63, 0.12)",
        "state.pressed": "rgba(231, 196, 63, 0.24)",
        "state.inactive": "rgba(53, 42, 6, 0.56)",
        "state.inactive.subtle": "rgba(53, 42, 6, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#352a06",
        "base.inverted.subtle": "#f3efd8",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#826c00",
        "base.on.intent": "#1d1500",
        "base.on.intent.subtle": "#675300",
        "state.disabled": "rgba(53, 42, 6, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#675300",
        "state.pressed": "#675300",
        "state.inactive": "rgba(29, 21, 0, 0.72)",
        "state.inactive.strong": "#352a06",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(130, 108, 0, 0.32)",
        "base.strong": "#e7c43f",
        "base.subtle": "rgba(130, 108, 0, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(231, 196, 63, 0.32)",
        "base.intent.strong": "#e7c43f",
        "base.intent.subtle": "rgba(231, 196, 63, 0.16)",
        "state.disabled": "rgba(53, 42, 6, 0.12)",
        "state.hover": "rgba(231, 196, 63, 0.12)",
        "state.pressed": "rgba(231, 196, 63, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(29, 21, 0, 0.64)",
        "state.inactive.subtle": "rgba(53, 42, 6, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "cash": {
      "background": {
        "base.background": "#f2f2fe",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#292648",
        "base.surface.inverted": "#292648",
        "base.inset": "rgba(172, 168, 255, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#6b7388",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(41, 38, 72, 0.04)",
        "state.hover": "rgba(172, 168, 255, 0.12)",
        "state.pressed": "rgba(172, 168, 255, 0.24)",
        "state.inactive": "rgba(41, 38, 72, 0.56)",
        "state.inactive.subtle": "rgba(41, 38, 72, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#ecedff",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#6b7388",
        "base.on.intent": "#f2f2fe",
        "base.on.intent.subtle": "#464c5b",
        "state.disabled": "rgba(41, 38, 72, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#5343ac",
        "state.pressed": "#5343ac",
        "state.inactive": "rgba(21, 20, 35, 0.72)",
        "state.inactive.strong": "#292648",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(107, 88, 217, 0.32)",
        "base.strong": "#6b58d9",
        "base.subtle": "rgba(107, 88, 217, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(107, 88, 217, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(107, 88, 217, 0.16)",
        "state.disabled": "rgba(41, 38, 72, 0.12)",
        "state.hover": "rgba(172, 168, 255, 0.12)",
        "state.pressed": "rgba(172, 168, 255, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(21, 20, 35, 0.64)",
        "state.inactive.subtle": "rgba(41, 38, 72, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "day-use": {
      "background": {
        "base.background": "#fdeff2",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#431d28",
        "base.surface.inverted": "#431d28",
        "base.inset": "rgba(255, 144, 173, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#6b7388",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(67, 29, 40, 0.04)",
        "state.hover": "rgba(255, 144, 173, 0.12)",
        "state.pressed": "rgba(255, 144, 173, 0.24)",
        "state.inactive": "rgba(67, 29, 40, 0.56)",
        "state.inactive.subtle": "rgba(67, 29, 40, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#fee9ed",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#6b7388",
        "base.on.intent": "#fdeff2",
        "base.on.intent.subtle": "#464c5b",
        "state.disabled": "rgba(67, 29, 40, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#9a204e",
        "state.pressed": "#9a204e",
        "state.inactive": "rgba(33, 16, 20, 0.72)",
        "state.inactive.strong": "#431d28",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(196, 44, 101, 0.32)",
        "base.strong": "#c42c65",
        "base.subtle": "rgba(196, 44, 101, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(196, 44, 101, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(196, 44, 101, 0.16)",
        "state.disabled": "rgba(67, 29, 40, 0.12)",
        "state.hover": "rgba(255, 144, 173, 0.12)",
        "state.pressed": "rgba(255, 144, 173, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(33, 16, 20, 0.64)",
        "state.inactive.subtle": "rgba(67, 29, 40, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "deals": {
      "background": {
        "base.background": "#f6f4e9",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#352a06",
        "base.surface.inverted": "#352a06",
        "base.inset": "rgba(231, 196, 63, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#e7c43f",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(53, 42, 6, 0.08)",
        "state.hover": "rgba(231, 196, 63, 0.12)",
        "state.pressed": "rgba(231, 196, 63, 0.24)",
        "state.inactive": "rgba(53, 42, 6, 0.56)",
        "state.inactive.subtle": "rgba(53, 42, 6, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#352a06",
        "base.inverted.subtle": "#f3efd8",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#24262c",
        "base.on.intent": "#1d1500",
        "base.on.intent.subtle": "#675300",
        "state.disabled": "rgba(53, 42, 6, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#675300",
        "state.pressed": "#675300",
        "state.inactive": "rgba(29, 21, 0, 0.72)",
        "state.inactive.strong": "#352a06",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(130, 108, 0, 0.32)",
        "base.strong": "#e7c43f",
        "base.subtle": "rgba(130, 108, 0, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(231, 196, 63, 0.32)",
        "base.intent.strong": "#e7c43f",
        "base.intent.subtle": "rgba(231, 196, 63, 0.16)",
        "state.disabled": "rgba(53, 42, 6, 0.12)",
        "state.hover": "rgba(231, 196, 63, 0.12)",
        "state.pressed": "rgba(231, 196, 63, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(29, 21, 0, 0.64)",
        "state.inactive.subtle": "rgba(53, 42, 6, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "family": {
      "background": {
        "base.background": "#f6f1fc",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#322343",
        "base.surface.inverted": "#322343",
        "base.inset": "rgba(201, 160, 248, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#6b7388",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(50, 35, 67, 0.08)",
        "state.hover": "rgba(201, 160, 248, 0.12)",
        "state.pressed": "rgba(201, 160, 248, 0.24)",
        "state.inactive": "rgba(50, 35, 67, 0.56)",
        "state.inactive.subtle": "rgba(50, 35, 67, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#f2ebfc",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#8c4ac8",
        "base.on.intent": "#f6f1fc",
        "base.on.intent.subtle": "#464c5b",
        "state.disabled": "rgba(50, 35, 67, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#6f3a9f",
        "state.pressed": "#6f3a9f",
        "state.inactive": "rgba(25, 18, 33, 0.64)",
        "state.inactive.strong": "#322343",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(140, 74, 200, 0.32)",
        "base.strong": "#8c4ac8",
        "base.subtle": "rgba(140, 74, 200, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(140, 74, 200, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(140, 74, 200, 0.16)",
        "state.disabled": "rgba(50, 35, 67, 0.12)",
        "state.hover": "rgba(201, 160, 248, 0.12)",
        "state.pressed": "rgba(201, 160, 248, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(25, 18, 33, 0.64)",
        "state.inactive.subtle": "rgba(50, 35, 67, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "flights": {
      "background": {
        "base.background": "#f6f1fc",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#322343",
        "base.surface.inverted": "#322343",
        "base.inset": "rgba(201, 160, 248, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#8c4ac8",
        "base.intent.subtle": "#f2ebfc",
        "state.disabled": "rgba(50, 35, 67, 0.08)",
        "state.hover": "rgba(201, 160, 248, 0.12)",
        "state.pressed": "rgba(201, 160, 248, 0.24)",
        "state.inactive": "rgba(50, 35, 67, 0.56)",
        "state.inactive.subtle": "rgba(50, 35, 67, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#f2ebfc",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#8c4ac8",
        "base.on.intent": "#f6f1fc",
        "base.on.intent.subtle": "#6f3a9f",
        "state.disabled": "rgba(50, 35, 67, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#6f3a9f",
        "state.pressed": "#6f3a9f",
        "state.inactive": "rgba(25, 18, 33, 0.64)",
        "state.inactive.strong": "#322343",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(140, 74, 200, 0.32)",
        "base.strong": "#8c4ac8",
        "base.subtle": "rgba(140, 74, 200, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(140, 74, 200, 0.32)",
        "base.intent.strong": "#8c4ac8",
        "base.intent.subtle": "rgba(140, 74, 200, 0.16)",
        "state.disabled": "rgba(50, 35, 67, 0.12)",
        "state.hover": "rgba(201, 160, 248, 0.12)",
        "state.pressed": "rgba(201, 160, 248, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(25, 18, 33, 0.64)",
        "state.inactive.subtle": "rgba(50, 35, 67, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "homes": {
      "background": {
        "base.background": "#ecf7ef",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#0f341c",
        "base.surface.inverted": "#0f341c",
        "base.inset": "rgba(96, 199, 129, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#007e3e",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(15, 52, 28, 0.08)",
        "state.hover": "rgba(96, 199, 129, 0.12)",
        "state.pressed": "rgba(96, 199, 129, 0.24)",
        "state.inactive": "rgba(15, 52, 28, 0.56)",
        "state.inactive.subtle": "rgba(15, 52, 28, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#e2f2e5",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#6b7388",
        "base.on.intent": "#ecf7ef",
        "base.on.intent.subtle": "#464c5b",
        "state.disabled": "rgba(15, 52, 28, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#00622f",
        "state.pressed": "#00622f",
        "state.inactive": "rgba(11, 26, 15, 0.64)",
        "state.inactive.strong": "#0f341c",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(0, 126, 62, 0.32)",
        "base.strong": "#007e3e",
        "base.subtle": "rgba(0, 126, 62, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(0, 126, 62, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(0, 126, 62, 0.16)",
        "state.disabled": "rgba(15, 52, 28, 0.12)",
        "state.hover": "rgba(96, 199, 129, 0.12)",
        "state.pressed": "rgba(96, 199, 129, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(11, 26, 15, 0.64)",
        "state.inactive.subtle": "rgba(15, 52, 28, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "hotels": {
      "background": {
        "base.background": "#fdf0ee",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#451f19",
        "base.surface.inverted": "#451f19",
        "base.inset": "rgba(255, 150, 133, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#c53829",
        "base.intent.subtle": "#fee9e5",
        "state.disabled": "rgba(69, 31, 25, 0.08)",
        "state.hover": "rgba(255, 150, 133, 0.12)",
        "state.pressed": "rgba(255, 150, 133, 0.24)",
        "state.inactive": "rgba(69, 31, 25, 0.56)",
        "state.inactive.subtle": "rgba(69, 31, 25, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#fee9e5",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#c53829",
        "base.on.intent": "#fdf0ee",
        "base.on.intent.subtle": "#9e2418",
        "state.disabled": "rgba(69, 31, 25, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#9e2418",
        "state.pressed": "#9e2418",
        "state.inactive": "rgba(34, 17, 14, 0.72)",
        "state.inactive.strong": "#451f19",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(197, 56, 41, 0.32)",
        "base.strong": "#c53829",
        "base.subtle": "rgba(197, 56, 41, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(197, 56, 41, 0.32)",
        "base.intent.strong": "#c53829",
        "base.intent.subtle": "rgba(197, 56, 41, 0.16)",
        "state.disabled": "rgba(69, 31, 25, 0.12)",
        "state.hover": "rgba(255, 150, 133, 0.12)",
        "state.pressed": "rgba(255, 150, 133, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(34, 17, 14, 0.64)",
        "state.inactive.subtle": "rgba(69, 31, 25, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "price": {
      "background": {
        "base.background": "#fdf0ee",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#451f19",
        "base.surface.inverted": "#451f19",
        "base.inset": "rgba(255, 150, 133, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#6b7388",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(69, 31, 25, 0.8)",
        "state.hover": "rgba(255, 150, 133, 0.12)",
        "state.pressed": "rgba(255, 150, 133, 0.24)",
        "state.inactive": "rgba(69, 31, 25, 0.56)",
        "state.inactive.subtle": "rgba(69, 31, 25, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#fee9e5",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#fdf0ee",
        "base.on.intent.subtle": "#464c5b",
        "base.intent": "#6b7388",
        "state.disabled": "rgba(14, 50, 48, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#9e2418",
        "state.pressed": "#9e2418",
        "state.inactive": "rgba(34, 17, 14, 0.72)",
        "state.inactive.strong": "#451f19",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(197, 56, 41, 0.32)",
        "base.strong": "#c53829",
        "base.subtle": "rgba(197, 56, 41, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(197, 56, 41, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(197, 56, 41, 0.16)",
        "state.disabled": "rgba(69, 31, 25, 0.12)",
        "state.hover": "rgba(255, 150, 133, 0.12)",
        "state.pressed": "rgba(255, 150, 133, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(34, 17, 14, 0.64)",
        "state.inactive.subtle": "rgba(69, 31, 25, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "primary": {
      "background": {
        "base.background": "#eef4fe",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#192b49",
        "base.surface.inverted": "#192b49",
        "base.inset": "rgba(133, 179, 255, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#6b7388",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(25, 43, 73, 0.08)",
        "state.hover": "rgba(133, 179, 255, 0.12)",
        "state.pressed": "rgba(133, 179, 255, 0.24)",
        "state.inactive": "rgba(25, 43, 73, 0.56)",
        "state.inactive.subtle": "rgba(25, 43, 73, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#e5efff",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#eef4fe",
        "base.on.intent.subtle": "#464c5b",
        "base.intent": "#6b7388",
        "state.disabled": "rgba(25, 43, 73, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#1751ae",
        "state.pressed": "#1751ae",
        "state.inactive": "rgba(14, 22, 36, 0.64)",
        "state.inactive.strong": "#192b49",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(32, 103, 218, 0.32)",
        "base.strong": "#2067da",
        "base.subtle": "rgba(32, 103, 218, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(32, 103, 218, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(32, 103, 218, 0.16)",
        "state.disabled": "rgba(25, 43, 73, 0.12)",
        "state.hover": "rgba(133, 179, 255, 0.12)",
        "state.pressed": "rgba(133, 179, 255, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(14, 22, 36, 0.64)",
        "state.inactive.subtle": "rgba(25, 43, 73, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "trips": {
      "background": {
        "base.background": "#ecf7ef",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#0f341c",
        "base.surface.inverted": "#0f341c",
        "base.inset": "rgba(96, 199, 129, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#007e3e",
        "base.intent.subtle": "#e2f2e5",
        "state.disabled": "rgba(15, 52, 28, 0.08)",
        "state.hover": "rgba(96, 199, 129, 0.12)",
        "state.pressed": "rgba(96, 199, 129, 0.24)",
        "state.inactive": "rgba(15, 52, 28, 0.56)",
        "state.inactive.subtle": "rgba(15, 52, 28, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#e2f2e5",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#ecf7ef",
        "base.on.intent.subtle": "#00622f",
        "base.intent": "#007e3e",
        "state.disabled": "rgba(15, 52, 28, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#00622f",
        "state.pressed": "#00622f",
        "state.inactive": "rgba(11, 26, 15, 0.64)",
        "state.inactive.strong": "#0f341c",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(0, 126, 62, 0.32)",
        "base.strong": "#007e3e",
        "base.subtle": "rgba(0, 126, 62, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(0, 126, 62, 0.32)",
        "base.intent.strong": "#007e3e",
        "base.intent.subtle": "rgba(0, 126, 62, 0.16)",
        "state.disabled": "rgba(15, 52, 28, 0.12)",
        "state.hover": "rgba(96, 199, 129, 0.12)",
        "state.pressed": "rgba(96, 199, 129, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(11, 26, 15, 0.64)",
        "state.inactive.subtle": "rgba(15, 52, 28, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "vip-bronze": {
      "background": {
        "base.background": "#faf2ee",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#3c251a",
        "base.surface.inverted": "#3c251a",
        "base.inset": "rgba(235, 162, 127, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#98471c",
        "base.intent.subtle": "#f8ebe6",
        "state.disabled": "rgba(60, 37, 26, 0.08)",
        "state.hover": "rgba(235, 162, 127, 0.12)",
        "state.pressed": "rgba(235, 162, 127, 0.24)",
        "state.inactive": "rgba(60, 37, 26, 0.56)",
        "state.inactive.subtle": "rgba(60, 37, 26, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#f8ebe6",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#faf2ee",
        "base.on.intent.subtle": "#7b472f",
        "base.intent": "#98471c",
        "state.disabled": "rgba(60, 37, 26, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#7b472f",
        "state.pressed": "#7b472f",
        "state.inactive": "rgba(30, 19, 14, 0.72)",
        "state.inactive.strong": "#3c251a",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(159, 92, 59, 0.32)",
        "base.strong": "#9f5c3b",
        "base.subtle": "rgba(159, 92, 59, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(159, 92, 59, 0.32)",
        "base.intent.strong": "#9f5c3b",
        "base.intent.subtle": "rgba(159, 92, 59, 0.16)",
        "state.disabled": "rgba(60, 37, 26, 0.12)",
        "state.hover": "rgba(235, 162, 127, 0.12)",
        "state.pressed": "rgba(235, 162, 127, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(30, 19, 14, 0.64)",
        "state.inactive.subtle": "rgba(60, 37, 26, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "vip-gold": {
      "background": {
        "base.background": "#f7f3e8",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#38280a",
        "base.surface.inverted": "#38280a",
        "base.inset": "rgba(233, 180, 82, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#464c5b",
        "base.intent.subtle": "#f4eedc",
        "state.disabled": "rgba(56, 40, 10, 0.08)",
        "state.hover": "rgba(233, 180, 82, 0.12)",
        "state.pressed": "rgba(233, 180, 82, 0.24)",
        "state.inactive": "rgba(56, 40, 10, 0.56)",
        "state.inactive.subtle": "rgba(56, 40, 10, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#38280a",
        "base.inverted.subtle": "#f4eedc",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#1d1406",
        "base.on.intent.subtle": "#704e00",
        "base.intent": "#906600",
        "state.disabled": "rgba(56, 40, 10, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#704e00",
        "state.pressed": "#704e00",
        "state.inactive": "rgba(29, 20, 6, 0.72)",
        "state.inactive.strong": "#38280a",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(144, 102, 0, 0.32)",
        "base.strong": "#e9b452",
        "base.subtle": "rgba(144, 102, 0, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(233, 180, 82, 0.32)",
        "base.intent.strong": "#e9b452",
        "base.intent.subtle": "rgba(233, 180, 82, 0.16)",
        "state.disabled": "rgba(56, 40, 10, 0.12)",
        "state.hover": "rgba(233, 180, 82, 0.12)",
        "state.pressed": "rgba(233, 180, 82, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(29, 20, 6, 0.64)",
        "state.inactive.subtle": "rgba(56, 40, 10, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "vip-platinum": {
      "background": {
        "base.background": "#edf4ff",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#202b3f",
        "base.surface.inverted": "#202b3f",
        "base.inset": "rgba(165, 183, 215, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#464c5b",
        "base.intent.subtle": "#e6efff",
        "state.disabled": "rgba(32, 43, 63, 0.08)",
        "state.hover": "rgba(165, 183, 215, 0.12)",
        "state.pressed": "rgba(165, 183, 215, 0.24)",
        "state.inactive": "rgba(32, 43, 63, 0.56)",
        "state.inactive.subtle": "rgba(32, 43, 63, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#e6efff",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#6b7388",
        "base.on.intent.subtle": "#475773",
        "base.intent": "#586b8e",
        "state.disabled": "rgba(32, 43, 63, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#475773",
        "state.pressed": "#475773",
        "state.inactive": "rgba(12, 17, 26, 0.72)",
        "state.inactive.strong": "#202b3f",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(88, 107, 142, 0.32)",
        "base.strong": "#586b8e",
        "base.subtle": "rgba(88, 107, 142, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(88, 107, 142, 0.32)",
        "base.intent.strong": "#586b8e",
        "base.intent.subtle": "rgba(88, 107, 142, 0.16)",
        "state.disabled": "rgba(32, 43, 63, 0.12)",
        "state.hover": "rgba(165, 183, 215, 0.12)",
        "state.pressed": "rgba(165, 183, 215, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(12, 17, 26, 0.64)",
        "state.inactive.subtle": "rgba(32, 43, 63, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "vip-prime": {
      "background": {
        "base.background": "#f6f1fc",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#322343",
        "base.surface.inverted": "#322343",
        "base.inset": "rgba(201, 160, 248, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#8c4ac8",
        "base.intent.subtle": "#f2ebfc",
        "state.disabled": "rgba(50, 35, 67, 0.08)",
        "state.hover": "rgba(201, 160, 248, 0.12)",
        "state.pressed": "rgba(201, 160, 248, 0.24)",
        "state.inactive": "rgba(50, 35, 67, 0.56)",
        "state.inactive.subtle": "rgba(50, 35, 67, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#f2ebfc",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#f6f1fc",
        "base.on.intent.subtle": "#6f3a9f",
        "base.intent": "#8c4ac8",
        "state.disabled": "rgba(50, 35, 67, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#6f3a9f",
        "state.pressed": "#6f3a9f",
        "state.inactive": "rgba(25, 18, 33, 0.72)",
        "state.inactive.strong": "#322343",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(140, 74, 200, 0.32)",
        "base.strong": "#8c4ac8",
        "base.subtle": "rgba(140, 74, 200, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(140, 74, 200, 0.32)",
        "base.intent.strong": "#8c4ac8",
        "base.intent.subtle": "rgba(140, 74, 200, 0.16)",
        "state.disabled": "rgba(50, 35, 67, 0.12)",
        "state.hover": "rgba(201, 160, 248, 0.12)",
        "state.pressed": "rgba(201, 160, 248, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(25, 18, 33, 0.64)",
        "state.inactive.subtle": "rgba(50, 35, 67, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "vip-silver": {
      "background": {
        "base.background": "#eff4fc",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#252c38",
        "base.surface.inverted": "#252c38",
        "base.inset": "rgba(171, 182, 203, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#5e6b82",
        "base.intent.subtle": "#aebedd",
        "state.disabled": "rgba(37, 44, 56, 0.08)",
        "state.hover": "rgba(171, 182, 203, 0.12)",
        "state.pressed": "rgba(171, 182, 203, 0.24)",
        "state.inactive": "rgba(37, 44, 56, 0.56)",
        "state.inactive.subtle": "rgba(37, 44, 56, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#e9effa",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#d0daee",
        "base.on.intent.subtle": "#4a5466",
        "base.intent": "#5e6b82",
        "state.disabled": "rgba(37, 44, 56, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#4a5466",
        "state.pressed": "#4a5466",
        "state.inactive": "rgba(13, 17, 24, 0.72)",
        "state.inactive.strong": "#252c38",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(94, 107, 130, 0.32)",
        "base.strong": "#5e6b82",
        "base.subtle": "rgba(94, 107, 130, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(94, 107, 130, 0.32)",
        "base.intent.strong": "#5e6b82",
        "base.intent.subtle": "rgba(94, 107, 130, 0.16)",
        "state.disabled": "rgba(37, 44, 56, 0.12)",
        "state.hover": "rgba(171, 182, 203, 0.12)",
        "state.pressed": "rgba(171, 182, 203, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(13, 17, 24, 0.64)",
        "state.inactive.subtle": "rgba(37, 44, 56, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "negative": {
      "background": {
        "base.background": "#fdf0ee",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#451f19",
        "base.surface.inverted": "#451f19",
        "base.inset": "rgba(255, 150, 133, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#6b7388",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(69, 31, 25, 0.08)",
        "state.hover": "rgba(255, 150, 133, 0.12)",
        "state.pressed": "rgba(255, 150, 133, 0.24)",
        "state.inactive": "rgba(69, 31, 25, 0.56)",
        "state.inactive.subtle": "rgba(69, 31, 25, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#fee9e5",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#6b7388",
        "base.on.intent": "#fdf0ee",
        "base.on.intent.subtle": "#464c5b",
        "state.disabled": "rgba(69, 31, 25, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#9e2418",
        "state.pressed": "#9e2418",
        "state.inactive": "rgba(34, 17, 14, 0.72)",
        "state.inactive.strong": "#451f19",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(197, 56, 41, 0.32)",
        "base.strong": "#c53829",
        "base.subtle": "rgba(197, 56, 41, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(197, 56, 41, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(197, 56, 41, 0.16)",
        "state.disabled": "rgba(69, 31, 25, 0.12)",
        "state.hover": "rgba(255, 150, 133, 0.12)",
        "state.pressed": "rgba(255, 150, 133, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(34, 17, 14, 0.64)",
        "state.inactive.subtle": "rgba(69, 31, 25, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "notice": {
      "background": {
        "base.background": "#eef4fe",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#192b49",
        "base.surface.inverted": "#192b49",
        "base.inset": "rgba(133, 179, 255, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#464c5b",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(25, 43, 73, 0.08)",
        "state.hover": "rgba(133, 179, 255, 0.12)",
        "state.pressed": "rgba(133, 179, 255, 0.24)",
        "state.inactive": "rgba(25, 43, 73, 0.56)",
        "state.inactive.subtle": "rgba(25, 43, 73, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#e5efff",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.intent": "#464c5b",
        "base.on.intent": "#eef4fe",
        "base.on.intent.subtle": "#1751ae",
        "state.disabled": "rgba(25, 43, 73, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#1751ae",
        "state.pressed": "#1751ae",
        "state.inactive": "rgba(14, 22, 36, 0.64)",
        "state.inactive.strong": "#192b49",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(32, 103, 218, 0.32)",
        "base.strong": "#2067da",
        "base.subtle": "rgba(32, 103, 218, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(32, 103, 218, 0.32)",
        "base.intent.strong": "#464c5b",
        "base.intent.subtle": "rgba(32, 103, 218, 0.16)",
        "state.disabled": "rgba(25, 43, 73, 0.12)",
        "state.hover": "rgba(133, 179, 255, 0.12)",
        "state.pressed": "rgba(133, 179, 255, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(14, 22, 36, 0.64)",
        "state.inactive.subtle": "rgba(25, 43, 73, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "positive": {
      "background": {
        "base.background": "#ecf7ef",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#0f341c",
        "base.surface.inverted": "#0f341c",
        "base.inset": "rgba(96, 199, 129, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#6b7388",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(15, 52, 28, 0.08)",
        "state.hover": "rgba(96, 199, 129, 0.12)",
        "state.pressed": "rgba(96, 199, 129, 0.24)",
        "state.inactive": "rgba(15, 52, 28, 0.56)",
        "state.inactive.subtle": "rgba(15, 52, 28, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#e2f2e5",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#ecf7ef",
        "base.on.intent.subtle": "#464c5b",
        "base.intent": "#6b7388",
        "state.disabled": "rgba(15, 52, 28, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#00622f",
        "state.pressed": "#00622f",
        "state.inactive": "rgba(11, 26, 15, 0.64)",
        "state.inactive.strong": "#0f341c",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(0, 126, 62, 0.32)",
        "base.strong": "#007e3e",
        "base.subtle": "rgba(0, 126, 62, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(0, 126, 62, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(0, 126, 62, 0.16)",
        "state.disabled": "rgba(15, 52, 28, 0.12)",
        "state.hover": "rgba(96, 199, 129, 0.12)",
        "state.pressed": "rgba(96, 199, 129, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(11, 26, 15, 0.64)",
        "state.inactive.subtle": "rgba(15, 52, 28, 0.12)",
        "state.active": "#6b7388"
      }
    },
    "urgent": {
      "background": {
        "base.background": "#fdf1eb",
        "base.background.strong": "#ffffff",
        "base.surface": "#ffffff",
        "base.surface.floating": "#ffffff",
        "base.surface.floating.inverted": "#43210f",
        "base.surface.inverted": "#43210f",
        "base.inset": "rgba(248, 157, 83, 0.16)",
        "base.overlay": "rgba(4, 7, 10, 0.64)",
        "base.overlay.subtle": "rgba(4, 7, 10, 0.24)",
        "base.overlay.strong": "rgba(4, 7, 10, 0.8)",
        "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
        "base.transparent": "rgba(255, 255, 255, 0)",
        "base.disabled": "rgba(37, 44, 56, 0.08)",
        "base.intent": "#6b7388",
        "base.intent.subtle": "#d8dfef",
        "state.disabled": "rgba(67, 33, 15, 0.08)",
        "state.hover": "rgba(248, 157, 83, 0.12)",
        "state.pressed": "rgba(248, 157, 83, 0.24)",
        "state.inactive": "rgba(67, 33, 15, 0.56)",
        "state.inactive.subtle": "rgba(67, 33, 15, 0.12)",
        "state.active": "#6b7388",
        "state.active.subtle": "rgba(107, 115, 136, 0.12)"
      },
      "text": {
        "base.default": "#252c38",
        "base.subtle": "rgba(13, 17, 24, 0.64)",
        "base.inverted": "#ffffff",
        "base.inverted.subtle": "#fdeae1",
        "base.disabled": "rgba(37, 44, 56, 0.24)",
        "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "base.on.intent": "#fdf1eb",
        "base.on.intent.subtle": "#464c5b",
        "base.intent": "#6b7388",
        "state.disabled": "rgba(67, 33, 15, 0.24)",
        "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
        "state.hover": "#8a3c0d",
        "state.pressed": "#8a3c0d",
        "state.inactive": "rgba(33, 18, 10, 0.72)",
        "state.inactive.strong": "#43210f",
        "state.active": "#6b7388",
        "state.on.active.subtle": "#464c5b"
      },
      "border": {
        "base.default": "rgba(181, 76, 1, 0.32)",
        "base.strong": "#f89d53",
        "base.subtle": "rgba(181, 76, 1, 0.16)",
        "base.inverted": "rgba(255, 255, 255, 0.32)",
        "base.inverted.strong": "#ffffff",
        "base.inverted.subtle": "rgba(255, 255, 255, 0.08)",
        "base.intent": "rgba(181, 76, 1, 0.32)",
        "base.intent.strong": "#6b7388",
        "base.intent.subtle": "rgba(181, 76, 1, 0.16)",
        "state.disabled": "rgba(67, 33, 15, 0.12)",
        "state.hover": "rgba(248, 157, 83, 0.12)",
        "state.pressed": "rgba(248, 157, 83, 0.24)",
        "state.focus": "#6b7388",
        "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
        "state.inactive": "rgba(33, 18, 10, 0.64)",
        "state.inactive.subtle": "rgba(67, 33, 15, 0.12)",
        "state.active": "#6b7388"
      }
    }
  },
  "background": {
    "deprecated.neutral.4": "#edf0f9",
    "deprecated.neutral.5": "#a8b3cb",
    "deprecated.neutral.alpha-1": "rgba(0, 0, 0, 0.16)",
    "deprecated.neutral.disabled-1": "#edf0f9",
    "deprecated.neutral.disabled-2": "#d8dfef",
    "deprecated.neutral.disabled-3": "#a8b3cb",
    "deprecated.neutral.disabled-4": "#6b7388",
    "deprecated.primary.brand": "#6b7388",
    "deprecated.primary.citycenter": "#6b7388",
    "deprecated.primary.easycancel": "#6b7388",
    "deprecated.primary.golocal": "#6b7388",
    "deprecated.primary.map-landmark": "#6b7388",
    "deprecated.primary.map-shopping": "#6b7388",
    "deprecated.primary.map-transportation": "#464c5b",
    "deprecated.primary.new": "#6b7388",
    "deprecated.primary.preferred": "#464c5b",
    "brand.1": "#464c5b",
    "brand.2": "#464c5b",
    "brand.3": "#464c5b",
    "brand.4": "#464c5b",
    "brand.5": "#464c5b",
    "brand.1.subtle": "#d8dfef",
    "brand.2.subtle": "#d8dfef",
    "brand.3.subtle": "#d8dfef",
    "brand.4.subtle": "#d8dfef",
    "brand.5.subtle": "#d8dfef",
    "product.vip-bronze.gradient": "linear-gradient(90deg, #9f5c3b 0%, #7b472f 100%)",
    "product.vip-bronze.subtle.gradient": "linear-gradient(90deg, #e7ac8c 0%, #cf7d4e 100%)",
    "product.vip-gold.gradient": "linear-gradient(90deg, #6b7388 0%, #464c5b 100%)",
    "product.vip-gold.subtle.gradient": "linear-gradient(90deg, #f4eedc 0%, #edd2a5 100%)",
    "product.vip-platinum.gradient": "linear-gradient(90deg, #586b8e 0%, #475773 100%)",
    "product.vip-platinum.subtle.gradient": "linear-gradient(90deg, #6b7388 0%, #464c5b 100%)",
    "product.vip-prime.gradient": "linear-gradient(90deg, #8c4ac8 0%, #1751ae 100%)",
    "product.vip-prime.subtle.gradient": "linear-gradient(90deg, #f2ebfc 0%, #bed7ff 100%)",
    "product.vip-silver.gradient": "linear-gradient(90deg, #5e6b82 0%, #4a5466 100%)",
    "product.vip-silver.subtle.gradient": "linear-gradient(90deg, #d0daee 0%, #aebedd 100%)",
    "product.rating-hotels": "#6b7388",
    "product.rating-hotels.subtle": "#d8dfef",
    "product.rating-homes": "#6b7388",
    "product.rating-homes.subtle": "#d8dfef",
    "product.agoda-pay": "#007e3e",
    "product.agoda-pay.subtle": "#e2f2e5",
    "partner.kakao": "#FEE500",
    "partner.line": "#07C656",
    "base.background": "#f6f8fc",
    "base.background.strong": "#ffffff",
    "base.disabled": "rgba(37, 44, 56, 0.08)",
    "base.inset": "rgba(171, 182, 203, 0.12)",
    "base.overlay": "rgba(0, 0, 0, 0.48)",
    "base.overlay.inverted": "rgba(255, 255, 255, 0.48)",
    "base.overlay.strong": "rgba(0, 0, 0, 0.8)",
    "base.overlay.subtle": "rgba(0, 0, 0, 0.32)",
    "base.surface": "#ffffff",
    "base.surface.floating": "#ffffff",
    "base.surface.floating.inverted": "#24262c",
    "base.surface.inverted": "#24262c",
    "base.transparent": "rgba(255, 255, 255, 0)",
    "feedback.generic": "#464c5b",
    "feedback.generic.subtle": "#edf0f9",
    "feedback.negative": "#6b7388",
    "feedback.negative.subtle": "#d8dfef",
    "feedback.notice": "#464c5b",
    "feedback.notice.subtle": "#d8dfef",
    "feedback.positive": "#6b7388",
    "feedback.positive.subtle": "#d8dfef",
    "feedback.urgent": "#6b7388",
    "feedback.urgent.subtle": "#d8dfef",
    "product.activities": "#e7c43f",
    "product.activities.subtle": "#f3efd8",
    "product.cash": "#6b7388",
    "product.cash.subtle": "#d8dfef",
    "product.day-use": "#6b7388",
    "product.day-use.subtle": "#d8dfef",
    "product.deals": "#e7c43f",
    "product.deals.subtle": "#d8dfef",
    "product.family": "#6b7388",
    "product.family.subtle": "#d8dfef",
    "product.flights": "#8c4ac8",
    "product.flights.subtle": "#f2ebfc",
    "product.homes": "#007e3e",
    "product.homes.subtle": "#d8dfef",
    "product.hotels": "#c53829",
    "product.hotels.subtle": "#fee9e5",
    "product.price": "#6b7388",
    "product.price.subtle": "#d8dfef",
    "product.primary": "#6b7388",
    "product.primary.subtle": "#d8dfef",
    "product.trips": "#007e3e",
    "product.trips.subtle": "#e2f2e5",
    "product.vip-bronze": "#98471c",
    "product.vip-bronze.subtle": "#f8ebe6",
    "product.vip-gold": "#464c5b",
    "product.vip-gold.subtle": "#f4eedc",
    "product.vip-platinum": "#464c5b",
    "product.vip-platinum.subtle": "#e6efff",
    "product.vip-prime": "#8c4ac8",
    "product.vip-prime.subtle": "#f2ebfc",
    "product.vip-silver": "#5e6b82",
    "product.vip-silver.subtle": "#aebedd",
    "base.intent": "#464c5b",
    "base.intent.subtle": "#edf0f9",
    "state.disabled": "rgba(37, 44, 56, 0.08)",
    "state.hover": "rgba(171, 182, 203, 0.12)",
    "state.pressed": "rgba(171, 182, 203, 0.24)",
    "state.inactive": "rgba(37, 44, 56, 0.56)",
    "state.inactive.subtle": "rgba(37, 44, 56, 0.12)",
    "state.active": "#6b7388",
    "state.active.subtle": "rgba(107, 115, 136, 0.12)"
  },
  "border": {
    "deprecated.neutral.4": "#a8b3cb",
    "deprecated.neutral.disabled-1": "#a8b3cb",
    "deprecated.primary.preferred": "#464c5b",
    "brand.1": "#464c5b",
    "brand.2": "#464c5b",
    "brand.3": "#464c5b",
    "brand.4": "#464c5b",
    "brand.5": "#464c5b",
    "brand.1.subtle": "#d8dfef",
    "brand.2.subtle": "#d8dfef",
    "brand.3.subtle": "#d8dfef",
    "brand.4.subtle": "#d8dfef",
    "brand.5.subtle": "#d8dfef",
    "product.rating-hotels": "rgba(181, 76, 1, 0.32)",
    "product.rating-hotels.subtle": "rgba(181, 76, 1, 0.16)",
    "product.rating-hotels.strong": "#6b7388",
    "product.rating-homes": "rgba(196, 44, 101, 0.32)",
    "product.rating-homes.subtle": "rgba(196, 44, 101, 0.16)",
    "product.rating-homes.strong": "#6b7388",
    "product.agoda-pay": "rgba(0, 126, 62, 0.32)",
    "product.agoda-pay.subtle": "rgba(0, 126, 62, 0.16)",
    "product.agoda-pay.strong": "#007e3e",
    "base.default": "#c1cbe0",
    "base.subtle": "#edf0f9",
    "base.inverted": "rgba(255, 255, 255, 0.32)",
    "base.inverted.strong": "#ffffff",
    "base.inverted.subtle": "rgba(255, 255, 255, 0.16)",
    "base.strong": "#c1cbe0",
    "feedback.generic": "rgba(94, 107, 130, 0.32)",
    "feedback.generic.strong": "#24262c",
    "feedback.generic.subtle": "rgba(94, 107, 130, 0.16)",
    "feedback.negative": "rgba(197, 56, 41, 0.32)",
    "feedback.negative.strong": "#6b7388",
    "feedback.negative.subtle": "rgba(197, 56, 41, 0.16)",
    "feedback.notice": "rgba(32, 103, 218, 0.32)",
    "feedback.notice.strong": "#464c5b",
    "feedback.notice.subtle": "rgba(32, 103, 218, 0.16)",
    "feedback.positive": "rgba(0, 126, 62, 0.32)",
    "feedback.positive.strong": "#6b7388",
    "feedback.positive.subtle": "rgba(0, 126, 62, 0.16)",
    "feedback.urgent": "rgba(181, 76, 1, 0.32)",
    "feedback.urgent.strong": "#6b7388",
    "feedback.urgent.subtle": "rgba(181, 76, 1, 0.16)",
    "product.activities": "rgba(231, 196, 63, 0.32)",
    "product.activities.strong": "#e7c43f",
    "product.activities.subtle": "rgba(231, 196, 63, 0.16)",
    "product.cash": "rgba(107, 88, 217, 0.32)",
    "product.cash.strong": "#6b7388",
    "product.cash.subtle": "rgba(107, 88, 217, 0.16)",
    "product.day-use": "rgba(196, 44, 101, 0.32)",
    "product.day-use.strong": "#6b7388",
    "product.day-use.subtle": "rgba(196, 44, 101, 0.16)",
    "product.deals": "rgba(231, 196, 63, 0.32)",
    "product.deals.strong": "#e7c43f",
    "product.deals.subtle": "rgba(231, 196, 63, 0.16)",
    "product.family": "rgba(140, 74, 200, 0.32)",
    "product.family.strong": "#6b7388",
    "product.family.subtle": "rgba(140, 74, 200, 0.16)",
    "product.flights": "rgba(140, 74, 200, 0.32)",
    "product.flights.strong": "#8c4ac8",
    "product.flights.subtle": "rgba(140, 74, 200, 0.16)",
    "product.homes": "rgba(0, 126, 62, 0.32)",
    "product.homes.strong": "#6b7388",
    "product.homes.subtle": "rgba(0, 126, 62, 0.16)",
    "product.hotels": "rgba(197, 56, 41, 0.32)",
    "product.hotels.strong": "#c53829",
    "product.hotels.subtle": "rgba(197, 56, 41, 0.16)",
    "product.price": "rgba(197, 56, 41, 0.32)",
    "product.price.strong": "#6b7388",
    "product.price.subtle": "rgba(197, 56, 41, 0.16)",
    "product.primary": "rgba(32, 103, 218, 0.32)",
    "product.primary.strong": "#6b7388",
    "product.primary.subtle": "rgba(32, 103, 218, 0.16)",
    "product.trips": "rgba(0, 126, 62, 0.32)",
    "product.trips.strong": "#007e3e",
    "product.trips.subtle": "rgba(0, 126, 62, 0.16)",
    "product.vip-bronze": "rgba(159, 92, 59, 0.32)",
    "product.vip-bronze.strong": "#9f5c3b",
    "product.vip-bronze.subtle": "rgba(159, 92, 59, 0.16)",
    "product.vip-gold": "rgba(233, 180, 82, 0.32)",
    "product.vip-gold.strong": "#e9b452",
    "product.vip-gold.subtle": "rgba(233, 180, 82, 0.16)",
    "product.vip-platinum": "rgba(88, 107, 142, 0.32)",
    "product.vip-platinum.strong": "#586b8e",
    "product.vip-platinum.subtle": "rgba(88, 107, 142, 0.16)",
    "product.vip-prime": "rgba(140, 74, 200, 0.32)",
    "product.vip-prime.strong": "#8c4ac8",
    "product.vip-prime.subtle": "rgba(140, 74, 200, 0.16)",
    "product.vip-silver": "rgba(94, 107, 130, 0.32)",
    "product.vip-silver.strong": "#5e6b82",
    "product.vip-silver.subtle": "rgba(94, 107, 130, 0.16)",
    "base.intent": "rgba(94, 107, 130, 0.32)",
    "base.intent.strong": "#24262c",
    "base.intent.subtle": "rgba(94, 107, 130, 0.16)",
    "state.disabled": "rgba(37, 44, 56, 0.12)",
    "state.hover": "rgba(171, 182, 203, 0.12)",
    "state.pressed": "rgba(171, 182, 203, 0.24)",
    "state.focus": "#6b7388",
    "state.focus.subtle": "rgba(107, 115, 136, 0.12)",
    "state.inactive": "rgba(13, 17, 24, 0.64)",
    "state.inactive.subtle": "rgba(37, 44, 56, 0.12)",
    "state.active": "#6b7388"
  },
  "text": {
    "deprecated.neutral.disabled-2": "#edf0f9",
    "deprecated.primary.easycancel": "#6b7388",
    "deprecated.primary.golocal": "#6b7388",
    "deprecated.primary.vip-gold": "#6b7388",
    "deprecated.secondary.interactive": "#24262c",
    "partner.on.kakao": "#000000",
    "product.rating-hotels": "#6b7388",
    "product.on.rating-hotels": "#fdf1eb",
    "product.on.rating-hotels.subtle": "#8a3c0d",
    "product.rating-homes": "#6b7388",
    "product.on.rating-homes": "#fdeff2",
    "product.on.rating-homes.subtle": "#9a204e",
    "product.agoda-pay": "#007e3e",
    "product.on.agoda-pay": "#ecf7ef",
    "product.on.agoda-pay.subtle": "#00622f",
    "base.default": "#24262c",
    "base.disabled": "#a8b3cb",
    "base.inverted": "#ffffff",
    "base.inverted.disabled": "rgba(255, 255, 255, 0.24)",
    "base.inverted.subtle": "#edf0f9",
    "base.subtle": "#6b7388",
    "feedback.generic": "#5e6b82",
    "feedback.negative": "#6b7388",
    "feedback.notice": "#464c5b",
    "feedback.on.generic": "#eff4fc",
    "feedback.on.generic.subtle": "#4a5466",
    "feedback.on.negative": "#fdf0ee",
    "feedback.on.negative.subtle": "#464c5b",
    "feedback.on.notice": "#eef4fe",
    "feedback.on.notice.subtle": "#1751ae",
    "feedback.on.positive": "#ecf7ef",
    "feedback.on.positive.subtle": "#464c5b",
    "feedback.on.urgent": "#fdf1eb",
    "feedback.on.urgent.subtle": "#464c5b",
    "feedback.positive": "#6b7388",
    "feedback.urgent": "#6b7388",
    "product.activities": "#826c00",
    "product.cash": "#6b7388",
    "product.day-use": "#6b7388",
    "product.deals": "#24262c",
    "product.family": "#8c4ac8",
    "product.flights": "#8c4ac8",
    "product.homes": "#6b7388",
    "product.hotels": "#c53829",
    "product.on.activities": "#1d1500",
    "product.on.activities.subtle": "#675300",
    "product.on.cash": "#f2f2fe",
    "product.on.cash.subtle": "#464c5b",
    "product.on.day-use": "#fdeff2",
    "product.on.day-use.subtle": "#464c5b",
    "product.on.deals": "#1d1500",
    "product.on.deals.subtle": "#675300",
    "product.on.family": "#f6f1fc",
    "product.on.family.subtle": "#464c5b",
    "product.on.flights": "#f6f1fc",
    "product.on.flights.subtle": "#6f3a9f",
    "product.on.homes": "#ecf7ef",
    "product.on.homes.subtle": "#464c5b",
    "product.on.hotels": "#fdf0ee",
    "product.on.hotels.subtle": "#9e2418",
    "product.on.price": "#fdf0ee",
    "product.on.price.subtle": "#464c5b",
    "product.on.primary": "#eef4fe",
    "product.on.primary.subtle": "#464c5b",
    "product.on.trips": "#ecf7ef",
    "product.on.trips.subtle": "#00622f",
    "product.on.vip-bronze": "#faf2ee",
    "product.on.vip-bronze.subtle": "#7b472f",
    "product.on.vip-gold": "#1d1406",
    "product.on.vip-gold.subtle": "#704e00",
    "product.on.vip-platinum": "#6b7388",
    "product.on.vip-platinum.subtle": "#475773",
    "product.on.vip-prime": "#f6f1fc",
    "product.on.vip-prime.subtle": "#6f3a9f",
    "product.on.vip-silver": "#d0daee",
    "product.on.vip-silver.subtle": "#4a5466",
    "product.price": "#6b7388",
    "product.primary": "#6b7388",
    "product.trips": "#007e3e",
    "product.vip-bronze": "#98471c",
    "product.vip-gold": "#906600",
    "product.vip-platinum": "#586b8e",
    "product.vip-prime": "#8c4ac8",
    "product.vip-silver": "#5e6b82",
    "base.intent": "#5e6b82",
    "base.on.intent": "#eff4fc",
    "base.on.intent.subtle": "#4a5466",
    "state.disabled": "rgba(37, 44, 56, 0.24)",
    "state.inverted.disabled": "rgba(255, 255, 255, 0.24)",
    "state.hover": "#4a5466",
    "state.pressed": "#4a5466",
    "state.inactive": "rgba(13, 17, 24, 0.64)",
    "state.inactive.strong": "#252c38",
    "state.active": "#6b7388",
    "state.on.active.subtle": "#464c5b"
  },
  "icons": {
    "8": "8px",
    "10": "10px",
    "12": "12px",
    "14": "14px",
    "16": "16px",
    "20": "20px",
    "24": "24px",
    "32": "32px",
    "48": "48px",
    "xs": "8px",
    "s": "12px",
    "m": "14px",
    "l": "16px",
    "xl": "20px",
    "xl2": "24px",
    "xl3": "32px",
    "xl4": "48px"
  },
  "radius": {
    "0": "0px",
    "1": "1px",
    "2": "2px",
    "4": "4px",
    "8": "8px",
    "12": "12px",
    "16": "16px",
    "24": "24px",
    "32": "32px",
    "48": "48px",
    "64": "64px",
    "none": "0px",
    "xs": "2px",
    "s": "4px",
    "m": "8px",
    "l": "16px",
    "xl": "24px",
    "max": "999px",
    "base": "999px"
  },
  "borderstyle": {
    "none": "none",
    "dotted": "dotted",
    "dashed": "dashed",
    "solid": "solid"
  },
  "borderwidth": {
    "0": "0px",
    "1": "1px",
    "2": "2px",
    "4": "4px",
    "8": "8px",
    "none": "0px",
    "s": "1px",
    "m": "2px"
  },
  "shadow": {
    "none": "none",
    "bottom-s": "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
    "bottom-m": "0px 2px 7px 0px rgba(0, 0, 0, 0.24)",
    "bottom-l": "0px 4px 10px 0px rgba(0, 0, 0, 0.24)",
    "center-s": "0px 0px 3px 1px rgba(0, 0, 0, 0.16)",
    "center-m": "0px 0px 7px 2px rgba(0, 0, 0, 0.24)",
    "center-l": "0px 0px 9px 4px rgba(0, 0, 0, 0.24)"
  },
  "spacing": {
    "0": "0px",
    "1": "1px",
    "2": "2px",
    "4": "4px",
    "8": "8px",
    "12": "12px",
    "16": "16px",
    "24": "24px",
    "32": "32px",
    "48": "48px",
    "64": "64px",
    "72": "72px",
    "none": "0px",
    "xs2": "2px",
    "xs": "4px",
    "s": "8px",
    "m": "12px",
    "l": "16px",
    "xl": "24px",
    "xl2": "32px",
    "xl3": "48px",
    "xl4": "64px",
    "-0": "-0px",
    "-1": "-1px",
    "-2": "-2px",
    "-4": "-4px",
    "-8": "-8px",
    "-12": "-12px",
    "-16": "-16px",
    "-24": "-24px",
    "-32": "-32px",
    "-48": "-48px",
    "-64": "-64px",
    "-72": "-72px",
    "-xs2": "-2px",
    "-xs": "-4px",
    "-s": "-8px",
    "-m": "-12px",
    "-l": "-16px",
    "-xl": "-24px",
    "-xl2": "-32px",
    "-xl3": "-48px",
    "-xl4": "-64px"
  },
  "typography": {
    "body-default-strong": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "fontSize": "16px",
      "lineHeight": "19px",
      "tag": "p"
    },
    "body-default": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 400,
      "fontSize": "16px",
      "lineHeight": "19px",
      "tag": "p"
    },
    "body-s-strong": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "fontSize": "14px",
      "lineHeight": "17px",
      "tag": "p"
    },
    "body-s": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 400,
      "fontSize": "14px",
      "lineHeight": "17px",
      "tag": "p"
    },
    "caption-default-strong": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "fontSize": "12px",
      "lineHeight": "14px",
      "tag": "span"
    },
    "caption-default": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 400,
      "fontSize": "12px",
      "lineHeight": "14px",
      "tag": "span"
    },
    "body-1-strong": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "fontSize": "16px",
      "lineHeight": "19px",
      "tag": "p"
    },
    "body-1": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 400,
      "fontSize": "16px",
      "lineHeight": "19px",
      "tag": "p"
    },
    "body-2-strong": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "fontSize": "14px",
      "lineHeight": "17px",
      "tag": "p"
    },
    "body-2": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 400,
      "fontSize": "14px",
      "lineHeight": "17px",
      "tag": "p"
    },
    "caption-1-strong": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "fontSize": "12px",
      "lineHeight": "14px",
      "tag": "span"
    },
    "caption-1": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 400,
      "fontSize": "12px",
      "lineHeight": "14px",
      "tag": "span"
    },
    "heading-3xl": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 700,
      "responsive": {
        "fontSize": {
          "min": 28,
          "max": 45
        },
        "lineHeight": {
          "min": 34,
          "max": 54
        }
      },
      "tag": "h1"
    },
    "heading-2xl": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 700,
      "responsive": {
        "fontSize": {
          "min": 26,
          "max": 37
        },
        "lineHeight": {
          "min": 31,
          "max": 44
        }
      },
      "tag": "h2"
    },
    "heading-xl": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "responsive": {
        "fontSize": {
          "min": 23,
          "max": 30
        },
        "lineHeight": {
          "min": 27,
          "max": 36
        }
      },
      "tag": "h1"
    },
    "heading-l": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "responsive": {
        "fontSize": {
          "min": 20,
          "max": 24
        },
        "lineHeight": {
          "min": 24,
          "max": 29
        }
      },
      "tag": "h2"
    },
    "heading-default": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "responsive": {
        "fontSize": {
          "min": 18,
          "max": 20
        },
        "lineHeight": {
          "min": 21,
          "max": 24
        }
      },
      "tag": "h3"
    },
    "display-1": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 700,
      "responsive": {
        "fontSize": {
          "min": 28,
          "max": 45
        },
        "lineHeight": {
          "min": 34,
          "max": 54
        }
      },
      "tag": "h1"
    },
    "display-2": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 700,
      "responsive": {
        "fontSize": {
          "min": 26,
          "max": 37
        },
        "lineHeight": {
          "min": 31,
          "max": 44
        }
      },
      "tag": "h2"
    },
    "heading-1": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "responsive": {
        "fontSize": {
          "min": 23,
          "max": 30
        },
        "lineHeight": {
          "min": 27,
          "max": 36
        }
      },
      "tag": "h1"
    },
    "heading-2": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "responsive": {
        "fontSize": {
          "min": 20,
          "max": 24
        },
        "lineHeight": {
          "min": 24,
          "max": 29
        }
      },
      "tag": "h2"
    },
    "heading-3": {
      "fontFamily": "SF Pro Display, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      "fontWeight": 600,
      "responsive": {
        "fontSize": {
          "min": 18,
          "max": 20
        },
        "lineHeight": {
          "min": 21,
          "max": 24
        }
      },
      "tag": "h3"
    }
  }
};

export { tokens as default };
//# sourceMappingURL=tokens.js.map
